import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, ICrudGetAction, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './zixun.reducer';
import { IZixun } from 'app/shared/model/zixun.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IZixunDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const ZixunDetail = (props: IZixunDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { zixunEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          <Translate contentKey="examsysApp.zixun.detail.title">Zixun</Translate> [<b>{zixunEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="title">
              <Translate contentKey="examsysApp.zixun.title">Title</Translate>
            </span>
          </dt>
          <dd>{zixunEntity.title}</dd>
          <dt>
            <span id="time">
              <Translate contentKey="examsysApp.zixun.time">Time</Translate>
            </span>
          </dt>
          <dd>{zixunEntity.time}</dd>
          <dt>
            <span id="isTop">
              <Translate contentKey="examsysApp.zixun.isTop">Is Top</Translate>
            </span>
          </dt>
          <dd>{zixunEntity.isTop ? 'true' : 'false'}</dd>
          <dt>
            <span id="author">
              <Translate contentKey="examsysApp.zixun.author">Author</Translate>
            </span>
          </dt>
          <dd>{zixunEntity.author}</dd>
          <dt>
            <span id="content">
              <Translate contentKey="examsysApp.zixun.content">Content</Translate>
            </span>
          </dt>
          <dd dangerouslySetInnerHTML={{__html: zixunEntity.content}}></dd>
        </dl>
        <Button tag={Link} to="/zixun" replace color="info">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/zixun/${zixunEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ zixun }: IRootState) => ({
  zixunEntity: zixun.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ZixunDetail);
